export const selectDashboardCustomFiscalDate = state =>
  state.dashboard.customFiscalDate
export const selectDashboardGoLive = state => state.dashboard.goLive
